export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./YoutubeTemplate.vue?vue&type=template&id=68840f39&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/YoutubeTemplate.vue?vue&type=template&id=68840f39&
// module id = 118
// module chunks = 9